// extracted by mini-css-extract-plugin
export default {"container":"T","isNarrow":"U","blinking":"V","gradientShift":"W","float":"X","move":"Y","scroll":"Z"};